//axios.js
import axios from 'axios'
import store from './store'
import router from './router'

var instance = axios.create({
    timeout: 10000,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    baseURL:'/api',
});

//request拦截器
instance.interceptors.request.use(
    config => {
        //判断是否存在token，如果存在的话，则每个http header都加上token
        if (store.state.token) {
            config.headers.Authorization = `${store.state.token}`;
        }
        return config;
    }
);

//respone拦截器
instance.interceptors.response.use(
    response => {
        return response;
    },
    error => { //默认除了2XX之外的都是错误的，就会走这里
        if (error.response && error.response.status === 401) {
            let vJumpLogin = true;

            if (store != null) {
                let token = store.state.token;
                let userid = store.state.userid;

                if (userid != null) {
                    userid = userid.toString();
                }

                if (token != null && token.length > 0
                    && userid != null && userid.length > 0
                    && token.length > userid.length) {
                    vJumpLogin = false;
                }
            }

            if (vJumpLogin) {
                // 退出登录
                store.dispatch('UserLogout');

                router.push({ //跳转到登录页面
                    name: 'login',
                    query: { redirect: router.currentRoute.name } // 将跳转的路由path作为参数，登录成功后跳转到该路由
                });
            }
        }
        return Promise.reject(error.response);
    }
);

export default instance
